/* eslint import/no-cycle: 0 */
import { Fragment } from 'react';
import { Text } from '@kanda-libs/ks-design-library';

interface ViewComponentProps {
  /**
   * Kanda job object
   */
  items?: string[];
  /**
   * Kanda job object
   */
  isLoading?: boolean;
}

const ViewComponent = ({ items = [], isLoading }: ViewComponentProps) => (
  <div className="flex flex-row flex-wrap mb-1">
    {items.map((item, index) => (
      <Fragment key={item}>
        {index !== 0 && (
          <div className="w-0.75 h-0.75 my-auto mx-2 bg-neutral-500 rounded-full" />
        )}
        <Text
          text={item}
          isLoading={isLoading}
          className="text-12-18 text-neutral-600"
          skeletonProps={{
            width: 80,
          }}
        />
      </Fragment>
    ))}
  </div>
);

ViewComponent.displayName = 'JobSidebar-Bullets-view';

ViewComponent.defaultProps = {
  items: [],
  isLoading: false,
};

export default ViewComponent;
